/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUniverseSystemsSystemIdPlanet } from './GetUniverseSystemsSystemIdPlanet';
import {
    GetUniverseSystemsSystemIdPlanetFromJSON,
    GetUniverseSystemsSystemIdPlanetFromJSONTyped,
    GetUniverseSystemsSystemIdPlanetToJSON,
    GetUniverseSystemsSystemIdPlanetToJSONTyped,
} from './GetUniverseSystemsSystemIdPlanet';
import type { GetUniverseSystemsSystemIdPosition } from './GetUniverseSystemsSystemIdPosition';
import {
    GetUniverseSystemsSystemIdPositionFromJSON,
    GetUniverseSystemsSystemIdPositionFromJSONTyped,
    GetUniverseSystemsSystemIdPositionToJSON,
    GetUniverseSystemsSystemIdPositionToJSONTyped,
} from './GetUniverseSystemsSystemIdPosition';

/**
 * 200 ok object
 * @export
 * @interface GetUniverseSystemsSystemIdOk
 */
export interface GetUniverseSystemsSystemIdOk {
    /**
     * The constellation this solar system is in
     * @type {number}
     * @memberof GetUniverseSystemsSystemIdOk
     */
    constellationId: number;
    /**
     * name string
     * @type {string}
     * @memberof GetUniverseSystemsSystemIdOk
     */
    name: string;
    /**
     * planets array
     * @type {Array<GetUniverseSystemsSystemIdPlanet>}
     * @memberof GetUniverseSystemsSystemIdOk
     */
    planets?: Array<GetUniverseSystemsSystemIdPlanet>;
    /**
     * 
     * @type {GetUniverseSystemsSystemIdPosition}
     * @memberof GetUniverseSystemsSystemIdOk
     */
    position: GetUniverseSystemsSystemIdPosition;
    /**
     * security_class string
     * @type {string}
     * @memberof GetUniverseSystemsSystemIdOk
     */
    securityClass?: string;
    /**
     * security_status number
     * @type {number}
     * @memberof GetUniverseSystemsSystemIdOk
     */
    securityStatus: number;
    /**
     * star_id integer
     * @type {number}
     * @memberof GetUniverseSystemsSystemIdOk
     */
    starId?: number;
    /**
     * stargates array
     * @type {Array<number>}
     * @memberof GetUniverseSystemsSystemIdOk
     */
    stargates?: Array<number>;
    /**
     * stations array
     * @type {Array<number>}
     * @memberof GetUniverseSystemsSystemIdOk
     */
    stations?: Array<number>;
    /**
     * system_id integer
     * @type {number}
     * @memberof GetUniverseSystemsSystemIdOk
     */
    systemId: number;
}

/**
 * Check if a given object implements the GetUniverseSystemsSystemIdOk interface.
 */
export function instanceOfGetUniverseSystemsSystemIdOk(value: object): value is GetUniverseSystemsSystemIdOk {
    if (!('constellationId' in value) || value['constellationId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('securityStatus' in value) || value['securityStatus'] === undefined) return false;
    if (!('systemId' in value) || value['systemId'] === undefined) return false;
    return true;
}

export function GetUniverseSystemsSystemIdOkFromJSON(json: any): GetUniverseSystemsSystemIdOk {
    return GetUniverseSystemsSystemIdOkFromJSONTyped(json, false);
}

export function GetUniverseSystemsSystemIdOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseSystemsSystemIdOk {
    if (json == null) {
        return json;
    }
    return {
        
        'constellationId': json['constellation_id'],
        'name': json['name'],
        'planets': json['planets'] == null ? undefined : ((json['planets'] as Array<any>).map(GetUniverseSystemsSystemIdPlanetFromJSON)),
        'position': GetUniverseSystemsSystemIdPositionFromJSON(json['position']),
        'securityClass': json['security_class'] == null ? undefined : json['security_class'],
        'securityStatus': json['security_status'],
        'starId': json['star_id'] == null ? undefined : json['star_id'],
        'stargates': json['stargates'] == null ? undefined : json['stargates'],
        'stations': json['stations'] == null ? undefined : json['stations'],
        'systemId': json['system_id'],
    };
}

export function GetUniverseSystemsSystemIdOkToJSON(json: any): GetUniverseSystemsSystemIdOk {
    return GetUniverseSystemsSystemIdOkToJSONTyped(json, false);
}

export function GetUniverseSystemsSystemIdOkToJSONTyped(value?: GetUniverseSystemsSystemIdOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'constellation_id': value['constellationId'],
        'name': value['name'],
        'planets': value['planets'] == null ? undefined : ((value['planets'] as Array<any>).map(GetUniverseSystemsSystemIdPlanetToJSON)),
        'position': GetUniverseSystemsSystemIdPositionToJSON(value['position']),
        'security_class': value['securityClass'],
        'security_status': value['securityStatus'],
        'star_id': value['starId'],
        'stargates': value['stargates'],
        'stations': value['stations'],
        'system_id': value['systemId'],
    };
}

